module.exports = __webpack_public_path__ + "img/ic_zfb.24e1d353.png";